export const notifyMessage = {
  success: 'Success',
  failed: 'Failed',
  loginError: 'Email or password is invalid'
};
